import { animate, style, transition, trigger } from "@angular/animations";
import {
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	Output,
	ViewChild
} from "@angular/core";

const fadeAnimation = trigger("fade", [
	transition(":enter", [
		style({ opacity: 0 }),
		animate("300ms", style({ opacity: 1 }))
	]),
	transition(":leave", [animate("300ms", style({ opacity: 0 }))])
]);

const slideUpAnimation = trigger("slideUp", [
	transition(":enter", [
		style({ transform: "translateY(100%)" }),
		animate("400ms cubic-bezier(0.17, 0, 0.24, 0)")
	]),
	transition(":leave", [
		animate("400ms ease-in-out", style({ transform: "translateY(100%)" }))
	])
]);

@Component({
	selector: "app-bottom-sheet",
	templateUrl: "./bottom-sheet.component.html",
	styleUrls: ["./bottom-sheet.component.scss"],
	animations: [fadeAnimation, slideUpAnimation],
	standalone: false
})
export class BottomSheetComponent {
	@Input()
	fullscreen = false;

	@Output()
	closeBtnEvent = new EventEmitter<boolean>();

	@Input()
	show = false;

	@ViewChild("backdrop")
	backdrop!: ElementRef;

	@HostListener("document:click", ["$event"])
	setInputBlur(event: PointerEvent): void {
		if (
			event.target &&
			this.backdrop &&
			event.target === this.backdrop.nativeElement
		) {
			this.emitCloseBtnEvent();
		}
	}

	protected emitCloseBtnEvent(): void {
		this.closeBtnEvent.emit(false);
	}
}
